/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
/**
 * @hidden
 */
var EventProxy = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EventProxy, _super);
    function EventProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseWheel = null;
        _this.onMouseWheelHorizontal = null;
        _this.onPinchStarted = null;
        _this.onPinchDelta = null;
        _this.onGestureCompleted = null;
        _this.onZoomStarted = null;
        _this.onZoomDelta = null;
        _this.onZoomCompleted = null;
        _this.onFlingStarted = null;
        _this.onContactStarted = null;
        _this.onDragStarted = null;
        _this.onContactMoved = null;
        _this.onDragDelta = null;
        _this.onContactCompleted = null;
        _this.onDragCompleted = null;
        _this.onMouseLeave = null;
        _this.onMouseOver = null;
        _this.onMouseEnter = null;
        _this.onMouseDown = null;
        _this.onMouseUp = null;
        _this.onDoubleTap = null;
        _this.onHold = null;
        _this.onKeyDown = null;
        _this.onKeyUp = null;
        _this.bf = null;
        _this.bc = 0;
        _this.ai = false;
        _this.ak = null;
        _this.am = null;
        _this.an = null;
        _this.ao = null;
        _this.z = false;
        _this.aa = false;
        _this.al = null;
        return _this;
    }
    EventProxy.prototype.ab = function (a, b, c) {
        if (this.am != null) {
            return this.am(a, b, c);
        }
        return this.ak(a);
    };
    EventProxy.prototype.get_aj = function () {
        return false;
    };
    Object.defineProperty(EventProxy.prototype, "aj", {
        get: function () {
            return this.get_aj();
        },
        enumerable: true,
        configurable: true
    });
    EventProxy.prototype.ag = function (a, b) {
        if (this.onMouseWheel != null && !this.ac) {
            return this.onMouseWheel(a, b);
        }
        return false;
    };
    EventProxy.prototype.ah = function (a, b) {
        if (this.onMouseWheelHorizontal != null && !this.ac) {
            return this.onMouseWheelHorizontal(a, b);
        }
        return false;
    };
    EventProxy.prototype.a7 = function (a, b) {
        if (this.onPinchStarted != null && !this.ac) {
            this.onPinchStarted(a, b);
        }
    };
    EventProxy.prototype.ba = function (a, b, c, d) {
        if (this.onZoomStarted != null && !this.ac) {
            this.onZoomStarted(a, b, c, d);
        }
    };
    EventProxy.prototype.ad = function (a, b, c) {
        if (this.onFlingStarted != null && !this.ac) {
            return this.onFlingStarted(a, b, c);
        }
        return true;
    };
    EventProxy.prototype.a6 = function (a, b) {
        if (this.onPinchDelta != null && !this.ac) {
            this.onPinchDelta(a, b);
        }
    };
    EventProxy.prototype.a9 = function (a, b, c, d) {
        if (this.onZoomDelta != null && !this.ac) {
            this.onZoomDelta(a, b, c, d);
        }
    };
    EventProxy.prototype.a8 = function (a, b, c, d) {
        if (this.onZoomCompleted != null && !this.ac) {
            this.onZoomCompleted(a, b, c, d);
        }
    };
    EventProxy.prototype.az = function (a, b) {
        if (this.onGestureCompleted != null && !this.ac) {
            this.onGestureCompleted(a, b);
        }
    };
    EventProxy.prototype.au = function (a, b) {
        if (this.onContactStarted != null && !this.ac) {
            this.onContactStarted(a, b);
        }
    };
    EventProxy.prototype.ay = function (a) {
        if (this.onDragStarted != null && !this.ac) {
            this.onDragStarted(a);
        }
    };
    EventProxy.prototype.at = function (a, b) {
        if (this.onContactMoved != null && !this.ac) {
            this.onContactMoved(a, b);
        }
    };
    EventProxy.prototype.ax = function (a) {
        if (this.onDragDelta != null && !this.ac) {
            this.onDragDelta(a);
        }
    };
    EventProxy.prototype.as = function (a, b) {
        if (this.onContactCompleted != null && !this.ac) {
            this.onContactCompleted(a, b);
        }
    };
    EventProxy.prototype.aw = function (a) {
        if (this.onDragCompleted != null && !this.ac) {
            this.onDragCompleted(a);
        }
    };
    EventProxy.prototype.a3 = function (a) {
        if (this.onMouseLeave != null && !this.ac) {
            this.onMouseLeave(a);
        }
    };
    EventProxy.prototype.a4 = function (a, b, c) {
        if (this.onMouseOver != null && !this.ac) {
            this.onMouseOver(a, b, c);
        }
    };
    EventProxy.prototype.a2 = function (a) {
        if (this.onMouseEnter != null && !this.ac) {
            this.onMouseEnter(a);
        }
    };
    EventProxy.prototype.a1 = function (a) {
        if (this.onMouseDown != null && !this.ac) {
            this.onMouseDown(a);
        }
    };
    EventProxy.prototype.a5 = function (a) {
        if (this.onMouseUp != null && !this.ac) {
            this.onMouseUp(a);
        }
    };
    EventProxy.prototype.ae = function (a) {
        if (this.onKeyDown != null && !this.ac) {
            return this.onKeyDown(a);
        }
        return false;
    };
    EventProxy.prototype.af = function (a) {
        if (this.onKeyUp != null && !this.ac) {
            return this.onKeyUp(a);
        }
        return false;
    };
    EventProxy.prototype.av = function (a) {
        if (this.onDoubleTap != null && !this.ac) {
            this.onDoubleTap(a);
        }
    };
    EventProxy.prototype.a0 = function (a) {
        if (this.onHold != null && !this.ac) {
            this.onHold(a);
        }
    };
    Object.defineProperty(EventProxy.prototype, "ac", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            this.z = a;
            this.ar();
        },
        enumerable: true,
        configurable: true
    });
    EventProxy.prototype.ar = function () {
    };
    EventProxy.$t = markType(EventProxy, 'EventProxy');
    return EventProxy;
}(Base));
export { EventProxy };
//# sourceMappingURL=EventProxy.js.map
